export default __webpack_public_path__ + "static/media/Sarah_s Photo - Sarah Deepika.7ebb4fd0.JPG";